import {
  getGroupName,
  getSelectedPeriod,
} from "../../../../services/GroupContext";
import { copyrightMessage, formatDate } from "../utils/helpers";

export const getInstructionsSection = (_ExcelData, isClientFacing) => {
  const groupName = getGroupName();
  const selectedPeriodOfAccount = getSelectedPeriod();
  const period_start = formatDate(selectedPeriodOfAccount?.period_start);
  const period_end = formatDate(selectedPeriodOfAccount?.period_end);

  const getBoldSheetTitleText = (text) => {
    const splitIndex = text.indexOf(" - ");
    if (splitIndex === -1) {
      return text;
    }

    const title = text.substring(0, splitIndex);
    const description = text.substring(splitIndex + 3);

    return {
      richText: [
        { text: title, font: { bold: true } },
        { text: ` - ${description}` },
      ],
    };
  };

  const externalText = [
    [],
    [],
    [
      `This Schedule summarises the output of the CIR calculations of the ${groupName} CIR calculations for the period of account ${period_start} to ${period_end}.`,
    ],
    [],
    [
      "It has been prepared based on the data which you have entered into the CIR Analyser for the period of account. You remain responsible for the accuracy and completeness of any and all data inputs - any inaccuracy with the inputs is likely to lead to inaccuracy in the resulting calculations.",
    ],
    [],
    [
      "It is important that you review the output of the calculations and any draft CIR return fully for accuracy and consistency. The CIR calculations and draft return produced by the CIR Analyser will be based on the underlying information and data provided to the CIR Analyser by you. The CIR Analyser cannot independently verify this data - this remains your responsibility.",
    ],
    [],
    [
      "The return form incorporates a declaration by the company secretary or other authorised signatory, that to the best of their knowledge the return is correct and complete. It is therefore important that you understand and agree with the return and supporting computations before they are submitted to HMRC.",
    ],
    [],
    [
      "The CIR return must be submitted to HMRC by the relevant filing deadline, which is generally 12 months after the end of the Period of Account. Penalties may be incurred if the CIR return is filed late. It will remain your responsibility to ensure that you have prepared the calculations and return through the CIR Analyser in sufficient time to comply with the filing deadline.",
    ],
    [],
    [
      "You are required to comply with the CIR and general CTSA requirement to keep records in support of your returns for specified periods of time that can be more onerous than Companies Acts requirements. Generally, companies must keep and preserve all relevant records for at least six years after the end of the accounting period to which they relate, although this period can be extended if HMRC issue a notice to enquire into the company's return. The CIR Analyser will retain and store the data you provide, along with the relevant outputs, but it will remain your responsibility to ensure that the records you retain in respect of your CIR calculations are sufficient to meet the record keeping requirements.",
    ],
    [],
    ["The following schedules provide the following data:"],
    [],
    [
      getBoldSheetTitleText(
        "Group summary and companies - Sets out a summary of the calculations, the UK group companies, and the net tax interest expense/income and tax EBITDA of each.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "CIR Attributes - Provides a calculation of any unused interest allowance and / or excess debt cap of the group.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "CIR Calculations - Provides the CIR calculations for the group under the fixed and, where relevant, group ratio methodologies, along with the computation of disallowance / reactivation for the period.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "Accounting Periods (Full) - Shows the detailed inputs to the calculations for each relevant accounting period of every UK group company.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "Accounting Periods (Regarded) - Shows the detailed inputs to the calculations for each regarded accounting period of every UK group company. A regarded accounting period is the proportion (which may be 100%) of the accounting period which falls within the period of account.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "NGIE - Shows the adjustments which have been included in computing the NGIE amount.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "ANGIE - Shows the adjustments which have been included in computing the ANGIE amount.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "QNGIE - Shows the adjustments which have been included in computing the QNGIE amount.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "Group EBITDA - Shows the adjustments which have been included in computing the Group EBITDA amount.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "Allocated Restrictions - Shows the allocation of any disallowed amount between companies and accounting periods.",
      ),
    ],
    [],
    [
      getBoldSheetTitleText(
        "Allocated Reactivations - Shows the allocation of any reactivation amount between companies and accounting periods.",
      ),
    ],
  ];

  const internalText = [
    [],
    [],
    [],
    [],
    [],
    [],
    [groupName],
    [],
    ["Corporate Interest Restriction - Supporting Calculations"],
    [],
    [`Period of Account - ${period_start} - ${period_end}`],
    [],
    [],
    [],
    [
      {
        richText: [
          { text: "This document has been prepared only for " },
          { text: groupName, font: { color: { argb: "FFFF0000" } } },
          { text: " and solely for the purpose and on the terms agreed with " },
          { text: groupName, font: { color: { argb: "FFFF0000" } } },
          {
            text: ". We accept no liability (including for negligence) to anyone else in connection with this document, and it may not be provided to anyone else.",
          },
        ],
      },
    ],
    [
      "If you receive a request under freedom of information legislation to disclose any information we provided to you, you will consult with us promptly before any disclosure.",
    ],
    [
      "[This is a draft prepared for discussion purposes only and should not be relied upon; the contents are subject to amendment or withdrawal and our final conclusions and findings will be set out in our final deliverable.]",
    ],
    [copyrightMessage],
  ];

  return isClientFacing ? externalText : internalText;
};
